import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const FooterSettings = () => {
  const [form, setForm] = useState({
    brandTitle: '',
    brandHighlight: '',
    aboutText: '',
    socialTwitter: '',
    socialLinkedin: '',
    socialInstagram: '',
    socialWhatsapp: '',
    quickLinksText: '',
    servicesLinksText: '',
    addressText: '',
    phoneText: '',
    emailText: '',
    copyrightText: '',
    designerName: '',
    designerUrl: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchFooter = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/footer`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { footer } = res.data;
        if (footer) {
          setForm({
            brandTitle: footer.brandTitle || '',
            brandHighlight: footer.brandHighlight || '',
            aboutText: footer.aboutText || '',
            socialTwitter: footer.socialTwitter || '',
            socialLinkedin: footer.socialLinkedin || '',
            socialInstagram: footer.socialInstagram || '',
            socialWhatsapp: footer.socialWhatsapp || '',
            quickLinksText: Array.isArray(footer.quickLinks)
              ? footer.quickLinks.map((l) => `${l.path}||${l.label}`).join('\n')
              : '',
            servicesLinksText: Array.isArray(footer.servicesLinks)
              ? footer.servicesLinks.map((l) => `${l.path}||${l.label}`).join('\n')
              : '',
            addressText: footer.addressText || '',
            phoneText: footer.phoneText || '',
            emailText: footer.emailText || '',
            copyrightText: footer.copyrightText || '',
            designerName: footer.designerName || '',
            designerUrl: footer.designerUrl || '',
          });
        }
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    };

    fetchFooter();
  }, []);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');

    const token = localStorage.getItem('adminToken');
    if (!token) {
      setError('انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.');
      setSaving(false);
      return;
    }

    const quickLinks = form.quickLinksText
      ? form.quickLinksText
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const [path, label] = line.split('||');
            return { path: (path || '').trim(), label: (label || '').trim() };
          })
      : [];

    const servicesLinks = form.servicesLinksText
      ? form.servicesLinksText
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const [path, label] = line.split('||');
            return { path: (path || '').trim(), label: (label || '').trim() };
          })
      : [];

    try {
      await axios.put(
        `${API_BASE_URL}/api/admin/footer`,
        {
          ...form,
          quickLinks,
          servicesLinks,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('تم حفظ إعدادات الفوتر بنجاح.');
    } catch (err) {
      const message = err.response?.data?.message || 'حدث خطأ أثناء الحفظ.';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>جاري تحميل إعدادات الفوتر...</p>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">إعدادات الفوتر</h2>
      <p className="admin-section-subtitle">
        يمكنك هنا تعديل محتوى الفوتر بما في ذلك النص التعريفي، الروابط السريعة، خدماتنا، ومعلومات
        التواصل وحقوق النشر.
      </p>

      {error && <div className="admin-section-error">{error}</div>}
      {success && <div className="admin-section-success">{success}</div>}

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>اسم العلامة (قبل الفراغ)</label>
          <input
            type="text"
            value={form.brandTitle}
            onChange={(e) => updateField('brandTitle', e.target.value)}
            placeholder="نبض"
          />
        </div>
        <div className="admin-field">
          <label>اسم العلامة (بعد الفراغ / مميز)</label>
          <input
            type="text"
            value={form.brandHighlight}
            onChange={(e) => updateField('brandHighlight', e.target.value)}
            placeholder="كير"
          />
        </div>
      </div>

      <div className="admin-field">
        <label>النص التعريفي القصير</label>
        <textarea
          rows={3}
          value={form.aboutText}
          onChange={(e) => updateField('aboutText', e.target.value)}
          style={{ resize: 'vertical' }}
          placeholder="نبض كير شريكك الاستراتيجي في المملكة العربية السعودية..."
        />
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>رابط تويتر (X)</label>
          <input
            type="text"
            value={form.socialTwitter}
            onChange={(e) => updateField('socialTwitter', e.target.value)}
            placeholder="https://x.com/..."
          />
        </div>
        <div className="admin-field">
          <label>رابط لينكدإن</label>
          <input
            type="text"
            value={form.socialLinkedin}
            onChange={(e) => updateField('socialLinkedin', e.target.value)}
            placeholder="https://www.linkedin.com/company/..."
          />
        </div>
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>رابط إنستغرام</label>
          <input
            type="text"
            value={form.socialInstagram}
            onChange={(e) => updateField('socialInstagram', e.target.value)}
            placeholder="https://www.instagram.com/..."
          />
        </div>
        <div className="admin-field">
          <label>رابط واتساب</label>
          <input
            type="text"
            value={form.socialWhatsapp}
            onChange={(e) => updateField('socialWhatsapp', e.target.value)}
            placeholder="https://wa.me/9665xxxxxxx"
          />
        </div>
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>روابط سريعة (كل سطر: المسار ثم || ثم النص)</label>
          <textarea
            rows={6}
            value={form.quickLinksText}
            onChange={(e) => updateField('quickLinksText', e.target.value)}
            style={{ resize: 'vertical' }}
            placeholder={
              '/||الرئيسية\n/about||من نحن\n/services||خدماتنا\n/contact||تواصل معنا\n/faq||الأسئلة الشائعة\n/policy||سياسة الاستخدام والخصوصية\n/licenses||التراخيص والاعتمادات\n/certificates||الشهادات'
            }
          />
        </div>

        <div className="admin-field">
          <label>روابط الخدمات (كل سطر: المسار ثم || ثم النص)</label>
          <textarea
            rows={6}
            value={form.servicesLinksText}
            onChange={(e) => updateField('servicesLinksText', e.target.value)}
            style={{ resize: 'vertical' }}
            placeholder={
              '/service/1||هيئة الغذاء والدواء\n/service/2||وزارة الصناعة\n/service/3||التخليص الجمركي\n/service/6||إصدار شهادات سابر\n/service/5||خدمات منصة نَمَا'
            }
          />
        </div>
      </div>

      <div className="admin-field">
        <label>العنوان في الفوتر</label>
        <input
          type="text"
          value={form.addressText}
          onChange={(e) => updateField('addressText', e.target.value)}
          placeholder="الرياض، حي العليا، طريق الملك فهد"
        />
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>هاتف الفوتر</label>
          <input
            type="text"
            value={form.phoneText}
            onChange={(e) => updateField('phoneText', e.target.value)}
            placeholder="+966573394229"
          />
        </div>
        <div className="admin-field">
          <label>البريد الإلكتروني في الفوتر</label>
          <input
            type="email"
            value={form.emailText}
            onChange={(e) => updateField('emailText', e.target.value)}
            placeholder="info@consulting.sa"
          />
        </div>
      </div>

      <div className="admin-field">
        <label>نص حقوق النشر</label>
        <input
          type="text"
          value={form.copyrightText}
          onChange={(e) => updateField('copyrightText', e.target.value)}
          placeholder="جميع الحقوق محفوظة © 2026 نبض كير."
        />
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>اسم المصمم / المطور</label>
          <input
            type="text"
            value={form.designerName}
            onChange={(e) => updateField('designerName', e.target.value)}
            placeholder="عبدالرحمن الصاوي"
          />
        </div>
        <div className="admin-field">
          <label>رابط المصمم / المطور</label>
          <input
            type="text"
            value={form.designerUrl}
            onChange={(e) => updateField('designerUrl', e.target.value)}
            placeholder="https://abdelrahmanelsawy.elsawi.art/"
          />
        </div>
      </div>

      <div className="admin-actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default FooterSettings;

